import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from 'react-redux';
import { setSound, playSong, selectCommon } from '../../common/actions/common.actions';
// import GearIcon from "../../../assets/icons/Gear.svg";
// import TranslateIcon from "../../../assets/icons/Google Translate.svg";
// import WhiteTranslate from "../../../assets/icons/whiteTranslate.svg";
// import LockIcon from "../../../assets/icons/Secure.svg";
// import SpeakerIcon from "../../../assets/icons/Speaker.svg";
// import WhiteSpeaker from "../../../assets/icons/whiteSpeaker.svg";
// import WhiteGear from "../../../assets/icons/whiteGear.svg";
// import WhiteLock from "../../../assets/icons/whiteSecure.svg";
import { Link, useNavigate } from "react-router-dom";
// import forwardArrow from "../../../assets/icons/left-arrow.png";
// import backArrow from "../../../assets/icons/Back.svg";
import { IoIosArrowBack } from "react-icons/io";
import { LiaLanguageSolid } from "react-icons/lia";
import { RiLockPasswordFill } from "react-icons/ri";
import { AiFillSound } from "react-icons/ai";
import { BsGear } from "react-icons/bs";

const Setting = () => {
  const dispatch = useDispatch();
  const { soundOn } = useSelector(selectCommon)
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  // add akn for click song
  const handleSongClick = async () => {
    dispatch(playSong());
  };

  const handleCardClick = () => {
    dispatch(playSong());
    dispatch(setSound());
  };

  const onChangeLanguage = () => {
    handleSongClick();
    i18n.changeLanguage(i18n.language === "en" ? "mm" : "en");
    localStorage.setItem("language", i18n.language);
  };

  const handleBackClick = () => {
    navigate("/dashboard");
  };

  const handleChangePasswordClick = (e) => {
    handleSongClick();
    e.preventDefault();
    navigate("/change-password")
  }

  return (
    <div className="w-full flex flex-col font-dangrek h-screen bg-gradient-to-br from-[#EAEAEA] via-green-50 to-[#228B22]/10 relative">

      {/* Header */}
      <div className="relative z-10 bg-gradient-to-r from-[#228B22] via-emerald-600 to-[#1F5F1F] py-4 px-4 shadow-sm">
        <div className="flex items-center">
          <button
            className="w-10 h-10 mr-4 flex justify-center items-center text-white rounded-xl active:bg-white/20"
            onClick={handleBackClick}
          >
            <IoIosArrowBack size={25} />
          </button>
          <div>
            <h3 className="text-white font-bold text-xl">Settings</h3>
            <p className="text-emerald-100 text-xs font-medium">App Configuration</p>
          </div>
        </div>
      </div>

      {/* Settings Options */}
      <div className="relative z-10 flex-1 p-4 overflow-auto">
        <div className="space-y-3">
          {/* Language Setting */}
          <div
            onClick={onChangeLanguage}
            className="bg-white rounded-2xl p-4 border border-gray-200 shadow-sm active:bg-gray-50"
          >
            <div className="flex items-center">
              <div className="w-10 h-10 bg-[#228B22] rounded-full flex items-center justify-center mr-3">
                <LiaLanguageSolid size={20} className="text-white" />
              </div>
              <div className="flex-1">
                <h3 className="text-[#228B22] font-bold text-base">{t('language')}</h3>
                <p className="text-gray-500 text-xs">Change app language</p>
              </div>
              <div className="flex items-center">
                <span className="bg-[#FFD700] text-gray-900 px-2 py-0.5 rounded-full text-xs font-bold mr-2">
                  {i18n.language === 'en' ? 'EN' : 'MM'}
                </span>
              </div>
            </div>
          </div>

          {/* Change Password Setting */}
          <Link className="block" onClick={(e) => handleChangePasswordClick(e)}>
            <div className="bg-white rounded-2xl p-4 border border-gray-200 shadow-sm active:bg-gray-50">
              <div className="flex items-center">
                <div className="w-10 h-10 bg-[#FFD700] rounded-full flex items-center justify-center mr-3">
                  <RiLockPasswordFill size={20} className="text-gray-900" />
                </div>
                <div className="flex-1">
                  <h3 className="text-[#228B22] font-bold text-base">{t('changePassword')}</h3>
                  <p className="text-gray-500 text-xs">Update your password</p>
                </div>
              </div>
            </div>
          </Link>
        </div>
      </div>

      {/* Version Footer */}
      <div className="relative z-10 bg-gradient-to-r from-[#228B22] via-emerald-600 to-[#1F5F1F] p-3 shadow-sm">
        <div className="bg-white/90 rounded-2xl p-3 border border-white/30">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <span className="text-gray-700 font-medium text-sm">App Version</span>
            </div>
            <span className="bg-[#FFD700] text-gray-900 px-3 py-1 rounded-full text-xs font-bold">
              v1.0.2.2
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Setting;
